import { Component, OnInit, inject } from '@angular/core';
import { UntypedFormControl, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef, MatDialogTitle, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { MatFormField, MatLabel, MatSuffix, MatHint } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatIcon } from '@angular/material/icon';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-add-telephone-dialog',
    templateUrl: 'telephone-add-dialog.html',
    styleUrls: ['./telephone-add-dialog.css'],
    imports: [MatDialogTitle, FormsModule, MatFormField, MatLabel, MatInput, ReactiveFormsModule, MatIcon, MatSuffix, MatHint, MatDialogActions, MatButton, MatDialogClose]
})
export class TelephoneAddDialogComponent implements OnInit {
  dialogRef = inject<MatDialogRef<TelephoneAddDialogComponent>>(MatDialogRef);

  telephoneValue = '';
  telephone: UntypedFormControl = new UntypedFormControl(this.telephoneValue, [
    Validators.required,
    Validators.pattern('^(0[67][0-9]{8}|\\+?33[67][0-9]{8})$')
  ]);

  onNoClick(): void {
    this.dialogRef.close();
  }

  ngOnInit(): void {
    this.telephone.valueChanges.subscribe((value: string) => {
      this.telephone.patchValue(value.replace(/[^+0-9]/, ''), {emitEvent: false});
    });
  }
}
